export default __webpack_public_path__ + "static/media/meta-custo-api-oficial.fb6f4a0f.png";